import SeoLandingPage from "../components/SeoLandingPage";

const page = {
  path: "/intellihire",
  breadcrumbName: "Aptofy IntelliHire™",
  serviceType: "Intelligent Hiring Software",
  eyebrow: "Aptofy IntelliHire™",
  title: "Aptofy IntelliHire™ | Intelligent AI Hiring Software",
  description:
    "Aptofy IntelliHire™ is intelligent hiring software that uses AI agent interviews, real-time scoring, and proctoring to help teams hire faster with less bias.",
  keywords:
    "Aptofy IntelliHire, intelligent hiring software, AI hiring platform, smart hiring software, automated hiring, intelligent recruitment, AI interview hiring, AI recruiting software, bias-free hiring software",
  h1: "Aptofy IntelliHire™ — Intelligent Hiring Powered by AI Interviews",
  intro:
    "Stop losing weeks to scheduling and subjective first rounds. IntelliHire™ uses an AI agent to interview candidates, score responses in real time, and deliver structured reports so recruiters can shortlist with confidence.",
  sections: [
    {
      heading: "What Is Intelligent Hiring Software?",
      paragraphs: [
        "Intelligent hiring software uses AI to automate and standardize early-stage recruitment — screening, interviewing, scoring, and reporting — while keeping humans in charge of final decisions.",
        "Aptofy IntelliHire™ is built for teams that need speed and fairness together: structured interviews, cheat-resistant proctoring, and scorecards that hiring managers can actually use.",
      ],
    },
    {
      heading: "How IntelliHire™ Works",
      paragraphs: [
        "Define the role and evaluation criteria. Candidates complete an AI-led interview on their schedule. IntelliHire™ monitors integrity, scores verbal, non-verbal, and written signals, and produces a comprehensive report for shortlisting.",
      ],
      bullets: [
        "Role-specific AI agent interviews",
        "Real-time candidate scoring",
        "Proctored, cheat-resistant environment",
        "Fake candidate and impersonation checks",
        "Bias-reduced evaluation parameters",
        "Faster shortlists for human final rounds",
      ],
    },
    {
      heading: "Key Features",
      bullets: [
        "AI Agent Interviewing with customizable questions",
        "Video interview workflows with structured scoring",
        "Coding and scenario-based evaluation support",
        "Comprehensive skill and communication reports",
        "Interview-as-a-Service option for busy expert panels",
        "Carbon-efficient alternative to travel-heavy hiring",
      ],
    },
    {
      heading: "Benefits vs Traditional Interviews",
      paragraphs: [
        "Traditional first rounds are slow, hard to standardize, and expensive to scale. IntelliHire™ interviews more candidates against the same quality bar — so your experts only meet the people who are ready for a human conversation.",
      ],
      bullets: [
        "Up to 70% faster time-to-hire potential",
        "Less calendar coordination",
        "More consistent evaluations across interviewers",
        "Better candidate experience with flexible timing",
      ],
    },
    {
      heading: "Ideal Use Cases",
      bullets: [
        "High-volume campus and lateral hiring",
        "Remote and multi-city recruitment",
        "First-round screening before panel interviews",
        "Staffing agencies delivering interview-ready talent",
        "Startups hiring without a large TA bench",
      ],
    },
  ],
  faqs: [
    {
      question: "Does IntelliHire™ replace recruiters?",
      answer:
        "No. IntelliHire™ automates interviewing and screening so recruiters can focus on judgment, relationships, and final hiring calls.",
    },
    {
      question: "How does IntelliHire™ reduce hiring bias?",
      answer:
        "Every candidate is evaluated against the same structured parameters. AI-led interviews reduce interviewer-to-interviewer inconsistency in early rounds.",
    },
    {
      question: "Can we still run human interviews?",
      answer:
        "Yes. Most teams use IntelliHire™ for first- and second-round screening, then bring humans into final rounds with better shortlists.",
    },
    {
      question: "How is IntelliHire™ different from TalentOS™?",
      answer:
        "IntelliHire™ is the intelligent hiring and AI interview product. TalentOS™ is the talent operating system for pipelines and recruiter workflows. They work well together.",
    },
  ],
  ctaHeading: "Hire smarter with IntelliHire™",
  ctaText:
    "Request a demo or start a free trial to see Aptofy IntelliHire™ interview, score, and shortlist candidates in real time.",
};

export default function IntelliHirePage() {
  return <SeoLandingPage page={page} />;
}
